import { Badge } from 'antd';
import styled from 'styled-components';

export default styled(Badge)`
	// Add your styles here
`;
